import React, { useEffect, useState } from 'react';
import { Card, Typography, Avatar, Spin, Alert, Tag } from 'antd';
import {
  UserOutlined,
  MailOutlined,
  PhoneOutlined,
  ShopOutlined,
  GlobalOutlined,
} from '@ant-design/icons';
import axios from 'axios';

const { Title, Text } = Typography;

const Perfil = () => {
  const [usuario, setUsuario] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState(null);
  console.log(usuario)
  useEffect(() => {
    const obtenerDatos = async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await axios.get('https://elarigestion-production.up.railway.app/api/usuario', {
          headers: {
            Authorization: token,
          },
        });

        setUsuario(res.data);
      } catch (err) {
        setError('No se pudo cargar el perfil');
      } finally {
        setCargando(false);
      }
    };

    obtenerDatos();
  }, []);

  if (cargando) return <Spin tip="Cargando perfil..." />;
  if (error) return <Alert message={error} type="error" />;

  return (
    <Card
      title={<Title level={3} >Mi perfil</Title>}
      style={{
        maxWidth: 600,
        margin: '0 auto',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 24 }}>
              <Avatar
               size={64}
               src={usuario?.avatar || null}
               style={{
                 backgroundColor: usuario?.color_del_fondo || '#ffffff',
                 color: '#000',
                 fontWeight: 'bold',
                 fontSize: 24,
               }}
             >
               {
                 !usuario?.avatar && usuario?.nombre_completo
                   ? usuario?.nombre_completo.charAt(0).toUpperCase()
                   : null
               }
             </Avatar>

        <div style={{ marginLeft: 16 }}>
          <Title level={4} style={{ margin: 0,  }}>{usuario.nombre_completo}</Title>
          <Text>
            <MailOutlined /> {usuario.correo_electronico}
          </Text>
        </div>
      </div>

      <p><Text strong >Estado de cuenta:</Text> <Tag color="green">{usuario.estado_de_la_cuenta}</Tag></p>
      <p><PhoneOutlined /> <Text >{usuario.celular}</Text></p>
      <p><ShopOutlined /> <Text >{usuario.tipo_de_negocio}</Text></p>
    </Card>
  );
};

export default Perfil;
